import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import Form, { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule, CheckBox } from "devextreme-react/form";
import Request from "../../../components/api/Request";
import * as AppActions from '../../../actions/AppActions';
import { ToastType } from "../../../constants/Constants";
import { showToast, parseDate, parseApiDate } from "../../../utils/Utils";
import './RoleGroupDetail.scss';
//import { TreeList, FilterRow, Selection, SearchPanel, Column, RowDragging, Editing, } from 'devextreme-react/tree-list';
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging, Scrolling
    , Export, Summary, TotalItem, Editing
} from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';

const RolGroupDetail = (props) => {

    const dispatch = useDispatch();

    const [roleGroup, setRoleGroup] = useState();
    const [roleGroupDetail, setRoleGroupDetail] = useState();

    useEffect(() => { 
        getRoleGroup();
    }, [])

    const dataSource = new DataSource({
        store: new ArrayStore({
            data: roleGroupDetail,
            key: 'roleName'
        })
    });

    const getRoleGroup = () => {
        let id = -1;
        if (props.data && props.data.id) {
            id = props.data.id;
        }
        const request = new Request("/roleGroup/getKayit/" + id, "GET");
        return request.run()
            .then(response => {
                setRoleGroup(response.data.data);
                setRoleGroupDetail(response.data.data.roleGroupDetailDtoList)
                return {
                    data: response.data.data.roleGroupDetailDtoList,
                    totalCount: response.data.data.roleGroupDetailDtoList.length,
                    summary: 0,
                    groupCount: 0
                };
            });
    } 

    function kaydet(e) {


        let eksikBilgi = false;
        e.validationGroup.validators.map((a) => {
            if (a.validate().status !== "valid") {
                eksikBilgi = true;
            }
        }
        );
        if (eksikBilgi) {
            showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }
        let data = roleGroup;
        data.roleGroupDetailDtoList = roleGroupDetail;
       
        let method = "POST"
        let url = "/roleGroup/createKayit";
        if (data.id && data.id > 0) {
            method = "PUT";
            url = "/roleGroup/updateKayit";
        }

        const request = new Request(url, method, data);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }
            });

    }


    return (
        <div >
            <Form formData={roleGroup} colCount={1} id="form" labelLocation={"left"} className="option" >
                <Item itemType="group" colCount={1} colSpan={1}>
                    <Item disabled={false} dataField={'name'} editorType={'dxTextBox'} >
                        <RequiredRule message="Adı bilgisi gerekli" />
                        <Label text='Adı' />
                    </Item>
                </Item>

                <ButtonItem>
                    <ButtonOptions
                        onClick={(e) => { kaydet(e); }}
                        width={'100%'}
                        type={'success'}
                        useSubmitBehavior={true}>
                        <span className="dx-button-text">
                            {'Kaydet'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>

            </Form>
            <DataGrid
                className={"roleGroupDetailGrid"}
                width="100%"
                //height="500px"
                dataSource={dataSource}
                key="roleName"
                keyExpr="roleName"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                selection={{ mode: 'single', deferred: true }}
            //remoteOperations={true}
            >
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    startEditAction="click"
                />
                <FilterRow visible={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />

                <Column dataField={'parent.parent.name'} width={200} caption={'Modül'} dataType="string" visible={true} groupIndex={0}  allowEditing={false} />
                <Column dataField={'parent.name'} width={200} caption={'Form'} dataType="string" visible={true} groupIndex={1}   allowEditing={false}/>
                <Column dataField={'name'} width={400} caption={'Adı'} dataType="string" visible={true}   allowEditing={false}/>
                <Column dataField={'enable'} width={50} caption={'Yetki'} dataType="boolean" visible={true}  allowEditing={true} />

            </DataGrid>


        </div>
    )
}

export default RolGroupDetail;
